(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable-next-line:no-any
function seriesP(tasks) {
    return tasks.reduce(function (acc, task) { return acc.then(task); }, Promise.resolve());
}
var jsonpCounter = 0;
function makeJSONPRequest(config) {
    return new Promise(function (resolve, reject) {
        var hash = "_jsonpCallback" + jsonpCounter++;
        var script = document.createElement('script');
        script.async = true;
        script.src = config.url.indexOf('?') >= 0
            ? config.url + "&_=" + Math.random() + "&callback=" + hash
            : config.url + "?_=" + Math.random() + "&callback=" + hash;
        script.onerror = function (e) {
            reject(e);
        };
        // tslint:disable-next-line:no-any
        window[hash] = function (data) {
            document.head.removeChild(script);
            // tslint:disable-next-line:no-any
            delete window[hash];
            resolve(data);
        };
        document.head.appendChild(script);
    });
}
function makeRequest(config) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        var url = config.url.indexOf('?') >= 0
            ? config.url + "&_=" + Math.random()
            : config.url + "?_=" + Math.random();
        xhr.open(config.method, url, true);
        if (typeof config.withCredentials !== 'undefined') {
            xhr.withCredentials = config.withCredentials;
        }
        else {
            xhr.withCredentials = true;
        }
        config.headers.forEach(function (header) {
            xhr.setRequestHeader(header[0], header[1]);
        });
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                try {
                    resolve(xhr.responseText);
                }
                catch (e) {
                    reject(e);
                }
            }
        };
        xhr.onerror = function (e) {
            reject(e);
        };
        if (config.body) {
            xhr.send(config.body);
        }
        else {
            xhr.send();
        }
    });
}
function logOut(host) {
    if (host === void 0) { host = ''; }
    return makeRequest({
        method: 'GET',
        url: host + "/api/users/logout-urls/",
        headers: [],
        withCredentials: false,
    }).then(function (body) {
        return processLinks(JSON.parse(body));
    });
}
exports.logOut = logOut;
function logOn(login, password, persistent, host) {
    if (host === void 0) { host = ''; }
    return makeRequest({
        method: 'POST',
        url: host + "/v1/validate-login-password",
        headers: [['Content-Type', 'application/x-www-form-urlencoded']],
        body: "login=" + encodeURIComponent(login) + "&" +
            ("password=" + encodeURIComponent(password)),
    })
        .then(function (body) {
        var res = JSON.parse(body);
        if (res.errors) {
            return Promise.reject(res);
        }
        return authenticate(res.logOnInfo, res.login, persistent);
    });
}
exports.logOn = logOn;
function processLinks(logoutLinks) {
    return seriesP(logoutLinks.map(function (logoutLink) {
        return function () { return performLogout(logoutLink); };
    }));
}
function performLogout(logoutUrl) {
    return makeJSONPRequest({
        url: logoutUrl,
    });
}
function authenticate(logOnInfoItems, login, persistent) {
    return seriesP(logOnInfoItems.map(function (logOnInfoItem) {
        return function () { return authenticateSite(logOnInfoItem, login, persistent); };
    }));
}
exports.authenticate = authenticate;
function authenticateSite(logOnInfo, login, persistent) {
    return makeJSONPRequest({
        url: logOnInfo.logOnUrl + "?" +
            ("login=" + encodeURIComponent(login) + "&") +
            ("token=" + logOnInfo.token + "&") +
            ("persistent=" + persistent),
    });
}


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// authenticator.js